import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const OrtamOlcumleriPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] bg-gradient-to-r from-rose-900 via-rose-800 to-pink-900 overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 border-2 border-white rounded-full animate-pulse"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-sound-module-line text-6xl text-rose-300"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold">Ortam Ölçümleri</h1>
            </div>
            <p className="text-xl md:text-2xl text-rose-100 leading-relaxed">
              İş yerlerinde sağlıklı ve güvenli çalışma ortamı için profesyonel ölçüm ve analiz hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          {/* Services Grid */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Ortam Ölçüm Hizmetlerimiz</h2>
              <p className="text-gray-700 text-lg max-w-3xl mx-auto">
                İşyeri ortam koşullarının bilimsel yöntemlerle ölçülmesi ve değerlendirilmesi
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 auto-rows-fr">
              {/* Card 1 */}
              <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-2xl p-8 border border-sky-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-sky-500 to-sky-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-sound-module-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Gürültü Ölçümü</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  İş yerinizdeki gürültü seviyelerini ölçerek, çalışanlarınızın işitme sağlığını korumak için gerekli önlemleri belirliyoruz.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 border border-amber-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-temp-hot-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Aydınlatma ve Termal Konfor</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  Çalışma ortamınızın aydınlatma ve sıcaklık koşullarını optimize ederek, çalışan verimliliğini artırıyoruz.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-flask-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Kimyasal Madde Ölçümü</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  Çalışma ortamındaki kimyasal madde konsantrasyonlarını ölçerek, sağlık risklerini minimize ediyoruz.
                </p>
              </div>
            </div>
          </div>

          {/* Standards Section */}
          <div className="mb-20 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12 border-2 border-gray-200">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Ölçüm Standartlarımız</h2>
              <p className="text-gray-700 text-lg max-w-2xl mx-auto">
                Tüm ölçümlerimiz ulusal ve uluslararası standartlara uygun olarak gerçekleştirilmektedir
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { standard: 'ISO 9612', desc: 'Gürültü Ölçümü' },
                { standard: 'TS EN 12464', desc: 'Aydınlatma' },
                { standard: 'ISO 5349', desc: 'Titreşim' },
                { standard: 'ISO 7243', desc: 'Termal Konfor' }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-lg border-2 border-gray-200">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-file-text-line text-5xl text-orange-600"></i>
                  </div>
                  <p className="font-bold text-gray-900 text-lg">{item.standard}</p>
                  <p className="text-sm text-gray-700">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-rose-600 via-rose-700 to-pink-700 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ortam Ölçümlerinizi Planlayın</h2>
            <p className="text-rose-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
              Akredite laboratuvarımız ve uzman ekibimizle iş yerinizde kapsamlı ortam ölçümleri gerçekleştiriyoruz
            </p>
            <Link 
              to="/iletisim"
              className="inline-flex items-center bg-white text-rose-600 px-10 py-5 rounded-2xl font-bold text-lg hover:bg-rose-50 transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Teklif Alın</span>
              <div className="w-6 h-6 flex items-center justify-center ml-3">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default OrtamOlcumleriPage;
